import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import Image from '../../images/bg1.jpg'


const Head = ({ title }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Helmet
      title={
        title
          ? `${title}  - ${data.site.siteMetadata.title}`
          : `${data.site.siteMetadata.title}`
      }
     
    >

    <meta property="og:site_name" content="Jassem Gaaloul || Fullstack Web Developer" />
    <meta property="og:title" content="Jassem Gaaloul || Fullstack Web Developer"/>
    <meta property="og:description" content="Jassem Gaaloul || Fullstack Web Developer"/>
    <meta property="og:image" itemprop="image" content="http://jassemcodes.vercel.com/static/aaa.jpg"/>
    <link itemprop="thumbnailUrl" href="http://jassemcodes.vercel.com/static/aaa.jpg"/>
    <meta property="og:image:type" content="image/jpg"/>
    <meta property="og:updated_time" content="updatedtime"/>
    <meta property="og:locale" content="en_GB" />
      <meta name="description" content="Jassem Gaaloul | Full-stack Developer" />

    </Helmet>
 
  )
}

export default Head
